import { arrayOf, bool, func, number, object, oneOfType } from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import { creativeShape } from '../../prop-types';
import {
  categories,
  compatibleProducts,
  countries,
  creativeActions,
  genders,
  imageType,
  mediaSet,
  nameColumn,
  origin,
  productTags,
  selectButton,
  size,
  thumbnail,
  uploadedBy,
} from '../creative-table-columns';

function CreativesTable({
  creatives,
  selectedCreatives,
  onSelection,
  onDeleteCreative,
  resizeCreativeImage,
  onChange,
  onFilter,
  tableRef,
  campaignRelatedProducts,
  onSuccess,
  campaignId,
}) {
  const compatibleProductsCell = compatibleProducts(
    campaignRelatedProducts,
    onSuccess,
    onDeleteCreative,
    resizeCreativeImage,
  );
  return (
    <ReactTable
      className="c-list-creatives small ReactTable--layout-card no-overflow"
      columns={[
        selectButton(onSelection, selectedCreatives),
        thumbnail,
        nameColumn(onChange),
        size,
        compatibleProductsCell(onChange, campaignId),
        mediaSet(onChange),
        productTags(onChange),
        genders(onChange),
        categories(onChange),
        countries(onChange),
        imageType(onChange),
        origin(onChange),
        uploadedBy,
        creativeActions(onDeleteCreative),
      ]}
      data={creatives}
      minRows={1}
      onFilteredChange={onFilter}
      ref={tableRef}
      getTrProps={(state, rowInfo) => {
        return rowInfo ? { 'data-qa-name': rowInfo.row.name } : {};
      }}
      defaultSorted={[
        {
          id: compatibleProductsCell.accessor,
          desc: true,
        },
      ]}
    />
  );
}

CreativesTable.propTypes = {
  creatives: arrayOf(creativeShape.isRequired).isRequired,
  selectedCreatives: arrayOf(number.isRequired),
  onSelection: func.isRequired,
  onDeleteCreative: func.isRequired,
  resizeCreativeImage: func.isRequired,
  onChange: func.isRequired,
  onFilter: func,
  tableRef: oneOfType([object, func]),
  campaignRelatedProducts: bool.isRequired,
  onSuccess: func.isRequired,
  campaignId: number,
};

CreativesTable.defaultProps = {
  selectedCreatives: [],
  onFilter: undefined,
  tableRef: undefined,
  campaignId: null,
};

export default CreativesTable;
